import TokenSupply from "./tokenSupply";

export default TokenSupply;
